<div class="flex justify-between items-center mb-4 mt-4">
  <div class="flex flex-1"></div>
  <div class="flex flex-1 justify-center">
    <elcia-period-navigator (periodChange)="setPeriod($event)" [initialDate]="periodStore.period().startDate"
                            [periodTypes]="[PeriodType.Month, PeriodType.Quarter, PeriodType.Year]"/>
  </div>
  <div class="flex flex-1 flex-row-reverse gap-2">
    <elcia-button (onClick)="menu.toggle($event)" [disabled]="isExporting() || store.rows().length === 0"
                  [icon]="'download'" [isLoading]="isExporting()" [label]="'accounting-export.action' | translate"/>
    <p-menu #menu [model]="menuItems" [popup]="true">
      <ng-template #item let-item>
        <a (click)="run(item.value); menu.hide()" class="p-menu-item-link cursor-pointer flex items-center gap-2">
          <span class="pi" [class]="item.icon"></span>
          {{ item.label | translate }}
        </a>
      </ng-template>
    </p-menu>
  </div>
</div>

<p-table [scrollable]="true" [size]="'small'" [value]="store.rows()" scrollHeight="flex">
  <ng-template #header>
    <tr>
      <th pSortableColumn="type">{{ 'accounting-export.type' | translate }}
        <p-sortIcon field="type"/>
      </th>
      <th pSortableColumn="number">{{ 'invoice.number' | translate }}
        <p-sortIcon field="number"/>
      </th>
      <th pSortableColumn="customerName">{{ 'entity.customer' | translate }}
        <p-sortIcon field="customerName"/>
      </th>
      <th pSortableColumn="legalEntityName">{{ 'entity.legal-entity' | translate }}
        <p-sortIcon field="legalEntityName"/>
      </th>
      <th pSortableColumn="date">{{ 'invoice.invoice-date' | translate }}
        <p-sortIcon field="date"/>
      </th>
      <th pSortableColumn="amountWithoutTax">{{ 'invoice.total-without-taxes' | translate }}
        <p-sortIcon field="amountWithoutTax"/>
      </th>
      <th pSortableColumn="accountingExportedAt">{{ 'accounting-export.exported-at' | translate }}
        <p-sortIcon field="accountingExportedAt"/>
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-row>
    <tr>
      <td>
        <span class="inline-flex text-xs font-bold rounded-full py-0.5 px-2"
              [class]="row.type === 'INVOICE' ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700'">
          {{ (row.type === 'INVOICE' ? 'accounting-export.type-invoice' : 'accounting-export.type-credit-note') | translate }}
        </span>
      </td>
      <td>{{ row.number }}</td>
      <td>{{ row.customerName }}</td>
      <td>{{ row.legalEntityName }}</td>
      <td>{{ row.date | date:'dd/MM/yyyy' }}</td>
      <td>{{ row.amountWithoutTax | currency:'EUR' }}</td>
      <td>{{ row.accountingExportedAt ? (row.accountingExportedAt | date:'dd/MM/yyyy') : '—' }}</td>
    </tr>
  </ng-template>
</p-table>
